import { Switch } from "@chakra-ui/react";
import React, { memo, useCallback } from "react";
import {
  AdminEditUserMutation,
  AdminEditUserMutationVariables,
  UserFragment,
} from "gql/graphql";
import { useMutation } from "@apollo/client";
import ADMIN_EDIT_USER_MUTATION from "../_networking/admin-edit-user";

interface IProps {
  user: UserFragment;
}

const AdminEditUserAllDistributionGroups = ({ user }: IProps) => {
  const [adminEditUserMutationAPI] = useMutation<
    AdminEditUserMutation,
    AdminEditUserMutationVariables
  >(ADMIN_EDIT_USER_MUTATION);

  const onChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      adminEditUserMutationAPI({
        variables: {
          id: user.id,
          input: {
            isAllDistributionGroups: e.target.checked === true,
          },
        },
        optimisticResponse: {
          adminEditUser: {
            ...user,
            isAllDistributionGroups: e.target.checked === true,
          },
        },
      });
    },
    [adminEditUserMutationAPI, user],
  );

  return (
    <Switch
      size="sm"
      defaultChecked={user.isAllDistributionGroups}
      onChange={onChange}
    />
  );
};

export default memo(AdminEditUserAllDistributionGroups);
